import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import { State, Action, Getter, Mutation } from 'vuex-class';

import Field from '@/../bower_components/teknisavuecomponents/assets/interfaces/Field';
import TkForm from '@/../bower_components/teknisavuecomponents/components/TkForm.vue';
import EditableTable from '@/../bower_components/teknisavuecomponents/components/grids/EditableTable.vue';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import DocumentosController from '@/assets/ts/controller/DocumentosController';
import FileUtils from '@/../bower_components/teknisavuecomponents/assets/utils/FileUtils';
import Util from '@/../bower_components/teknisavuecomponents/assets/utils/Util';

import NovaSolicitacaoController from '@/assets/ts/controller/NovaSolicitacaoController';
import AdmissaoController from '@/assets/ts/controller/AdmissaoController';
import DateUtil from '@/../bower_components/teknisavuecomponents/assets/utils/DateUtil';
import EditableTableColumn from '@/../bower_components/teknisavuecomponents/assets/interfaces/EditableTableColumn';
import EstruturaController from '@/assets/ts/controller/EstruturaController';



@Component({
  name: 'EstruturaPopup',
  components: {
    TkForm,
    EditableTable,
  },
})
class EstruturaPopup extends Vue {
  // #region [ PROPS ]
  @Prop({ default: () => {} })
  private readonly row: any;

  @Prop({ default: false })
  private readonly value: boolean;
  // #endregion

  // #region [ EVENTS ]
  @Emit('input')
  private emitInput(value: boolean) {}
  // #endregion

  // #region [ DATA ]
  private readonly cardTitle = 'Estrutura';

  private internalValue = false;

  private loading = {
    aniversariantes: false,
  };

  private lastLoadedNrEstrutura: string = null;

  private form = {
    defaultRow: {
      a: 10,
    } as const,
    fields: [
      {
        name: 'NMESTRUTURAH',
        label: 'Nome',
        type: 'text',
        size: 12,
      },
      {
        name: 'NMTIPOESTRUTURA',
        label: 'Tipo',
        type: 'text',
        size: 12,
        md: 6,
      },
      {
        name: 'TELEFONE_ESTRUT',
        label: 'Telefone',
        type: 'text',
        size: 12,
        md: 6,
      },
      {
        name: 'ENDERECO',
        label: 'Endereço',
        type: 'text',
        size: 12,
      },
      {
        name: 'NMPARCRESPINF',
        label: 'Responsável',
        type: 'text',
        size: 12,
      },
      {
        name: 'EMAIL_RESP',
        label: 'E-mail do Responsável',
        type: 'text',
        size: 12,
        md: 6,
      },
    ] as Field[],
    row: {} as any,
  };

  private grid = {
    columns: [
      {
        value: 'DTANIVERSARIO',
        text: 'Data',
      },
      {
        value: 'NMVINCULOM',
        text: 'Nome',
      },
      {
        value: 'NMESTRUTURAH',
        text: 'Unidade',
      },
      {
        value: 'DSEMAILOPER',
        text: 'E-mail',
      },
    ] as EditableTableColumn[],
    rows: [],
  };
  // #endregion

  // #region [ COMPUTED ]
  private get isLoading(): boolean {
    const loadingValues = Object.values(this.loading);
    const internalLoading = Util.oneTrue(...loadingValues);

    return internalLoading;
  }
  // #endregion

  // #region [ LIFECYCLE ]
  private created() {
    //
  }
  // #endregion

  // #region [ WATCHERS ]
  @Watch('row', { immediate: true })
  private rowOnChange() {
    this.createFormRow();
  }

  @Watch('value', { immediate: true })
  private valueOnChange() {
    this.internalValue = this.value;

    if (this.internalValue) {
      if (this.lastLoadedNrEstrutura !== this.row.NRESTRUTURAM) {
        this.loadAniversariantes();
      }
    }
  }
  // #endregion

  // #region [ METHODS ]
  private closeDialog(): void {
    this.internalValue = false;
    this.emitInput(this.internalValue);

    this.lastLoadedNrEstrutura = this.row.NRESTRUTURAM;
  }

  private createFormRow(): void {
    this.form.row = {
      ...this.form.defaultRow,
      ...this.row,
    };
  }

  private async loadAniversariantes(): Promise<void> {
    const nrEstrutura: string = this.row.NRESTRUTURAM;

    this.loading.aniversariantes = true;
    this.grid.rows = [];

    try {
      const aniversariantes = await EstruturaController.getAniversariantesEstrutura(nrEstrutura, false);

      if (nrEstrutura === this.row.NRESTRUTURAM) {
        this.grid.rows = aniversariantes;
      }
    } finally {
      this.loading.aniversariantes = false;
    }
  }

  private aniverRowStyle(row: any): string {
    const currentDate = DateUtil.getCurrentDate();
    const currentDayMonth = currentDate.substr(0, 5);

    const aniverIsCurrentDay = row.DTANIVERSARIO === currentDayMonth;

    if (aniverIsCurrentDay) {
      return 'font-weight: bolder;';
    }

    return undefined;
  }
  // #endregion
}

export default EstruturaPopup;
